import { and } from './and';
import { bart } from './bart';
import { cast } from './cast';
import { convert } from './convert';
import { concat } from './concat';
import { forex } from './forex';
import { if_func } from './if';
import { list } from './list';
import { list_contains } from './list_contains';
import { or } from './or';
import { ref, refSilent } from './ref';
import { coalesce } from './coalesce';
import { not_null } from './not_null';
import { date } from './date';
import { datetime } from './datetime';
import { normalize_string_pv2 } from './normalize_string_pv2';
import { not } from './not';
import { ends_with } from './ends_with';
import { starts_with } from './starts_with';
import { iferror } from './iferror';
import { Func, Macro } from '../types';
import { error } from './error';
import { convertible } from './convertible';

export const functions = new Map(
  Object.entries({
    cast,
    convert,
    bart,
    concat,
    convertible,
    error,
    forex,
    if: if_func,
    iferror,
    list,
    list_contains,
    ref,
    'ref?': refSilent,
    coalesce,
    not_null,
    date,
    datetime,
    normalize_string_pv2,
    and,
    or,
    not,
    ends_with,
    starts_with,
  })
);

let functionOverridesForTests: typeof functions | undefined = undefined;

export function overrideFunctionsForTests(
  overrides: typeof functions | undefined
): void {
  functionOverridesForTests = overrides;
}

export function getFunction(name: string): Func | Macro | undefined {
  if (functionOverridesForTests) {
    const override = functionOverridesForTests.get(name);
    if (override) {
      return override;
    }
  }
  return functions.get(name);
}
